import { render, staticRenderFns } from "./InsertsSidebar.vue?vue&type=template&id=03b716b2&scoped=true&"
import script from "./InsertsSidebar.vue?vue&type=script&lang=js&"
export * from "./InsertsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./InsertsSidebar.vue?vue&type=style&index=0&id=03b716b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b716b2",
  null
  
)

export default component.exports